export enum AuthErrorType {
    InvalidCredentials = 'INVALID_CREDENTIALS',
    EmailNotVerified = 'EMAIL_NOT_VERIFIED',
    RateLimitExceeded = 'RATE_LIMIT_EXCEEDED',
    NetworkError = 'NETWORK_ERROR',
    ServiceUnavailable = 'SERVICE_UNAVAILABLE',
    Unknown = 'UNKNOWN'
}

export interface AuthErrorMessage {
    title: string;
    message: string;
    action?: string;
}

export const AUTH_ERROR_MESSAGES: Record<AuthErrorType, AuthErrorMessage> = {
    [AuthErrorType.InvalidCredentials]: {
        title: 'Invalid Credentials',
        message: 'The email or password you entered is incorrect.',
        action: 'Please check your credentials and try again.'
    },
    [AuthErrorType.EmailNotVerified]: {
        title: 'Email Not Verified',
        message: 'Your email address has not been verified.',
        action: 'Please check your inbox for a verification email.'
    },
    [AuthErrorType.RateLimitExceeded]: {
        title: 'Too Many Attempts',
        message: 'You\'ve made too many sign-in attempts.',
        action: 'Please wait a few minutes before trying again.'
    },
    [AuthErrorType.NetworkError]: {
        title: 'Network Error',
        message: 'Unable to connect to the authentication service.',
        action: 'Please check your internet connection and try again.'
    },
    [AuthErrorType.ServiceUnavailable]: {
        title: 'Service Unavailable',
        message: 'The authentication service is temporarily unavailable.',
        action: 'Please try again later.'
    },
    [AuthErrorType.Unknown]: {
        title: 'Authentication Error',
        message: 'An unexpected error occurred.',
        action: 'Please try again or contact support if the problem persists.'
    }
};

export function getAuthErrorMessage(error: Error): AuthErrorMessage {
    // Map Supabase error messages to our error types
    const message = error.message.toLowerCase();
    
    if (message.includes('invalid credentials') || message.includes('invalid login')) {
        return AUTH_ERROR_MESSAGES[AuthErrorType.InvalidCredentials];
    }
    
    if (message.includes('email not confirmed') || message.includes('not verified')) {
        return AUTH_ERROR_MESSAGES[AuthErrorType.EmailNotVerified];
    }
    
    if (message.includes('rate limit') || message.includes('too many requests')) {
        return AUTH_ERROR_MESSAGES[AuthErrorType.RateLimitExceeded];
    }
    
    if (message.includes('network') || message.includes('connection')) {
        return AUTH_ERROR_MESSAGES[AuthErrorType.NetworkError];
    }
    
    if (message.includes('service') || message.includes('unavailable')) {
        return AUTH_ERROR_MESSAGES[AuthErrorType.ServiceUnavailable];
    }
    
    return AUTH_ERROR_MESSAGES[AuthErrorType.Unknown];
}
